import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { RecipientType } from '@40seas/entities/notifications';
import { z } from 'zod';

export const EntityCreatorRecipientsProviderPayloadSchema = z.object({
    type: EnumSchema(RecipientType),
});

export class EntityCreatorRecipientsProviderPayload extends FromSchema(EntityCreatorRecipientsProviderPayloadSchema) {
    type: RecipientType; // Primary/Secondary for output recipent types
}
